module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/right-img-538c9e11e5351860efc7e2179df37702.png";